module.exports = __webpack_public_path__ + "static/media/appgate-dark-logo.ed269acc.png";